export const ProfileRouting = [
  {
    path: "/contract/profile/list",
    name: "contract-profile-list",
    meta: { title: "工程合同" },
    component: () =>
      import(/* webpackChunkName: "contract-profile" */ "@/views/contract/profile/list/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/profile/create",
    name: "contract-profile-create",
    meta: { title: "工程合同登记", comName: "ContractProfileFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/contract/profile/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/contract/profile/edit/:id",
    name: "contract-profile-edit",
    meta: { title: "编辑工程合同", comName: "ContractProfileFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/contract/profile/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/contract/profile/detail/:id",
    name: "contract-profile-detail",
    meta: { title: "工程合同详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/contract/profile/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/contract/profile/flowPrint/:id",
    name: "contract-profile-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-profile" */ "@/views/contract/profile/flow-print/index.vue"
      ),
  },
];
